module.exports = __webpack_public_path__ + "img/19.ef99787d.jpg";